export default __webpack_public_path__ + "static/media/CinzelDecorative-Regular.25f648d1.ttf";